import clsx from 'clsx';
import type { GroupBase, OptionProps } from 'react-select';
import type { SelectorOption as SelectorOptionType } from '../../types';
import { checkIconStyles, optionLabelStyles, optionWrapperStyles } from './styles';
import CheckIcon from '/public/icons/check-tiny.svg';

interface SelectorOptionProps<Value extends string | number>
  extends OptionProps<SelectorOptionType<Value>, false, GroupBase<SelectorOptionType<Value>>> {
  intent: 'default' | 'old';
}

export const OptionWithCheckIcon = <Value extends string | number>(props: SelectorOptionProps<Value>) => {
  const { label, intent, innerProps, isSelected } = props;

  return (
    <div {...innerProps} className={clsx(optionWrapperStyles({ intent, isSelected }))}>
      <p className={optionLabelStyles({ intent })}>{label}</p>
      {isSelected && (
        <CheckIcon className={checkIconStyles({ intent })} />
      )}
    </div>
  );
};
